export class CoverageQuantitativeAssessmentDTO {
  layerName: string;
  icaoSelected: string[];
  geoJSON: string;
  calcID:string;
  elevation:string;
  selectedArea:string;
  selectedFIR:string;
  projectId:number;
}
